import React from "react";
import ProgramasNavigation from "../../components/ProgramasNavigation";
import { Super4ValorChart, Super4PercentualChart } from "../../components/Super4Charts";
import { useSuper4Data } from "../../hooks/useSuper4Data";



const Super4Page = () => {
  const { labels, dadosCimentos, dadosPremium, dadosColantes, dadosJs, dataAtualizacao, horaAtualizacao, isLoading, isRefreshing } = useSuper4Data();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <span className="text-[#1A2B49] font-semibold">Carregando...</span>
      </div>
    );
  }

  return (
    <>
      {isRefreshing && (
        <div className="container">
          <div className="w-[130px] flex mt-4 items-center gap-2 bg-[#01054C] rounded-md px-4 py-2 text-xs font-semibold text-[#fff] animate-pulse">
            <span className="rounded-full" />
            Atualizando...
          </div>
        </div>
      )}
      <ProgramasNavigation>
    <div className="container mt-4 pb-10 px-4">
      <h2 className="mb-4 text-xl font-bold text-[#01054C]">
        Super 4:
      </h2>
      <div>
        <div className="grid grid-cols-2 shadow gap-4 rounded-md" >
          <Super4ValorChart
            title="Positivação Cimentos"
            titleColor="#2ECC2E"
            labels={labels}
            data={dadosCimentos.data}
            colors={dadosCimentos.colors}
          />
          <Super4PercentualChart
            title="Premium de Preço"
            titleColor="#F5C800"
            labels={labels}
            data={dadosPremium.data}
            colors={dadosPremium.colors}
          />
        </div>
        <div className="grid grid-cols-2 shadow gap-4 mt-4 rounded-md" >
          <Super4ValorChart
            title="Positivação Colantes"
            titleColor="#4299E1"
            labels={labels}
            data={dadosColantes.data}
            colors={dadosColantes.colors}
          />
          <Super4PercentualChart
            title="JS+"
            titleColor="#CC2020"
            labels={labels}
            data={dadosJs.data}
            colors={dadosJs.colors}
          />
        </div>
      </div>
      <footer className="py-5 text-center text-[#8D96A8]">
        <p className="text-sm">
          Dados atualizados em: <span className="font-bold text-[#091D4A]">{dataAtualizacao}</span> as <span className="font-bold text-[#091D4A]">{horaAtualizacao}</span>
        </p>
        <p className="text-sm">Atualização uma vez ao dia com referência d-1</p>
      </footer>
    </div>
  </ProgramasNavigation>
    </>
  );
};

export default Super4Page;

